import getConfig from 'next/config';
import { ImageLoaderProps } from 'next/image';

import { getValidUrl } from './urlUtils';

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_RESOURCES_DOMAIN } = publicRuntimeConfig;

export const defaultLoader = ({ src, width, quality }: ImageLoaderProps) => {
  const validUrl = getValidUrl(src);
  if (!validUrl) return '';

  if (
    !validUrl.endsWith('.svg') &&
    NEXT_PUBLIC_RESOURCES_DOMAIN &&
    validUrl.includes(NEXT_PUBLIC_RESOURCES_DOMAIN)
  ) {
    const urlParts = validUrl.match(/^(.+)\/(.+\.\w+)$/);
    if (!urlParts) return validUrl;

    return `${urlParts[1]}/${width}q${quality || 75}/${urlParts[2]}`;
  }

  return `${validUrl}?w=${width}&q=${quality || 75}`;
};

export function thumbnailImage(imageSrc?: string) {
  return getCompressedImage(imageSrc, { width: 60 });
}

export function getCompressedImage(
  imageSrc?: string,
  size: { width?: number; quality?: number } = {}
) {
  if (!imageSrc) return;
  if (!size?.width) return getValidUrl(imageSrc);
  return defaultLoader({
    src: imageSrc || '',
    width: size?.width || 0,
    quality: size?.quality || 100
  });
}
